module.exports = __webpack_public_path__ + "static/TangleTower2-171024b57658bd65ce91d162ccf4104d.png";